import { useEffect, useState } from "react";

import TotpEnroller from "./TotpEnroller";
import BouncingDotsLoader from "./Loader/BouncingDotsLoader";
import { useTokenCache } from "../contexts/TokenCache";
import { useFeatureFlags } from "../contexts/FeatureFlags";


export default function OobeWrapper({ setLoggedIn, signOut, user, children }) {
  const [good, setGood] = useState(null);
  const { idToken } = useTokenCache();
  const { REQUIRE_GOOD_MFA } = useFeatureFlags();

  function isGood(idToken) {
    if (!REQUIRE_GOOD_MFA)
      return true;

    return !!idToken.payload.good_mfa;
  }

  useEffect(() => {
    const goodNow = isGood(idToken);
    setGood(goodNow);
    setLoggedIn(goodNow);
  }, [idToken, setLoggedIn]);

  if (good === null)
    return "";

  if (good)
    return children;

  return (
    <div
      className="formWidth"
      style={{
        display: "flex",
        placeSelf: "center",
        border: "1px solid hsl(210, 8%, 55%)",
        borderTop: "none",
        padding: "2.0rem",
        boxSizing: "border-box",
        flexDirection: "column",
        gap: "0rem",
      }}
    >
      <TotpEnroller user={user} />
      <p><button className="amplify-button amplify-button--link amplify-button--small amplify-button--fullwidth" onClick={signOut}>Cancel</button></p>
    </div>
  );
}
